
import { lazy } from 'react';

// Lazy loading ultra-optimisé avec imports dynamiques
export const LazyVosInspirations = lazy(() => 
  import('./VosInspirations').then(module => ({ default: module.default }))
);

export const LazyGallery = lazy(() => 
  import('./Gallery').then(module => ({ default: module.default }))
);

export const LazyPromiseSection = lazy(() => 
  import('./PromiseSection').then(module => ({ default: module.default }))
);

export const LazyProfessionalSection = lazy(() => 
  import('./ProfessionalSection').then(module => ({ default: module.default }))
);

export const LazyFaqSection = lazy(() => 
  import('./FaqSection').then(module => ({ default: module.default }))
);

export const LazyNewsletterSection = lazy(() => 
  import('./NewsletterSection').then(module => ({ default: module.default }))
);

export const LazyGoogleReviewSection = lazy(() => 
  import('./GoogleReviewSection').then(module => ({ default: module.default }))
);

export const LazyCTA = lazy(() => 
  import('./CTA').then(module => ({ default: module.default }))
);

// Sections events lazy pour optimiser TTI
export const LazyEventsSection = lazy(() => 
  import('./events/EventsSection').then(module => ({ default: module.default }))
);

export const LazyEventTypeSection = lazy(() => 
  import('./events/EventTypeSection').then(module => ({ default: module.default }))
);

// Composants admin séparés du bundle principal
export const LazyAdminComponents = {
  AdminDashboard: lazy(() => import('../pages/AdminDashboard')),
  AdminLogin: lazy(() => import('../pages/AdminLogin')),
  AdminEventDetail: lazy(() => import('../pages/AdminEventDetail')),
};

// Composants lourds pour les formulaires
export const LazyFormComponents = {
  Devis: lazy(() => import('../pages/Devis')),
  Contact: lazy(() => import('../pages/Contact')),
  NewEventRequest: lazy(() => import('../pages/NewEventRequest')),
};

// Composants de pages secondaires
export const LazyPageComponents = {
  BlogPage: lazy(() => import('../pages/BlogPage')),
  ArticleDetailPage: lazy(() => import('../pages/ArticleDetailPage')),
  Cart: lazy(() => import('../pages/Cart')),
};
